// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const AssetAttributeService = {};
// console.log("🚀 ~ AssetAttributeService:", AssetAttributeService);

AssetAttributeService.postAssetAttribute = function (data) {
  return lossClient({
    url: "/AssetAttribute/add",
    method: "post",
    data: data,
  });
};

AssetAttributeService.getAssetAttributeList = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  // console.log(
  //   "🚀 ~ file: AssetAttributeService.js:17 ~ userInputIndex:",
  //   userInputIndex
  // );
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  // console.log(
  //   "🚀 ~ file: AssetAttributeService.js:22 ~ decrementIndex:",
  //   decrementIndex
  // );
  return lossClient({
    url:
      "/AssetAttribute/search?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.code +
      "&desc=" +
      userInput.desc +
      "&status=" +
      userInput.status,
    method: "get",
  });
};

AssetAttributeService.getAssetAttributeApprovalList = function (userInput) {
  var userInputIndex = userInput.pageIndex;
  // console.log(
  //   "🚀 ~ file: AssetAttributeService.js:45 ~ userInputIndex:",
  //   userInputIndex
  // );
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  // console.log(
  //   "🚀 ~ file: AssetAttributeService.js:22 ~ decrementIndex:",
  //   decrementIndex
  // );
  return lossClient({
    url:
      "/AssetAttribute/approvalItems?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.code +
      "&desc=" +
      userInput.desc +
      "&status=" +
      userInput.status,
    method: "get",
  });
};

AssetAttributeService.putAssetAttributeApproval = function (data) {
  const requestDataValidation =
    data.approvalFlag.toLowerCase() == "return"
      ? {
          UserId: data.userId,
          Note: data.note,
          AssetAttributeId: data.assetTypeId,
        }
      : data.approvalFlag.toLowerCase() == "reject"
      ? {
          UserId: data.userId,
          Note: data.note,
          AssetAttributeId: data.assetTypeId,
        }
      : data.approvalFlag == "approve"
      ? {
          UserId: data.userId,
          Note: data.note,
          AssetAttributeId: data.assetTypeId,
        }
      : {
          UserId: data.userId,
          Note: data.note,
          AssetAttributeId: data.assetTypeId,
        };

  let urlRequest;
  const requestUrlValdiation =
    data.approvalFlag.toLowerCase() == "return"
      ? (urlRequest = "Return")
      : data.approvalFlag.toLowerCase() == "reject"
      ? (urlRequest = "Reject")
      : data.approvalFlag == "approve"
      ? (urlRequest = "Approve")
      : (urlRequest = "");

  // console.log("🚀 ~ data:", data);
  // console.log("🚀 ~ urlRequest:", urlRequest);
  // console.log("🚀 ~ requestUrlValdiation:", requestUrlValdiation);
  // console.log("🚀 ~ validData:", requestDataValidation);

  return lossClient({
    url: `/AssetAttribute/${urlRequest}`,
    method: "put",
    headers: {
      "X-requestid": data.id,
    },
    data: requestDataValidation,
  });
};

AssetAttributeService.putAssetAttributeRequest = function (data) {
  // console.log("🚀 ~ data:", data);

  var bodyRequest = {
    AssetAttributeId: data.AssetTypeId,
    Request: data.Request,
    note: data.note,
    userId: data.userId,
  };
  // console.log("🚀 ~ bodyRequest:", bodyRequest);
  return lossClient({
    url: `/AssetAttribute/${data.approvalFlag}`,
    method: "put",
    headers: {
      "X-requestid": data.AssetAttributeId,
    },
    data: bodyRequest,
  });
};

AssetAttributeService.getAssetAttributeDetail = function (data) {
  return lossClient({
    url: `/AssetAttribute/${data.id}`,
    method: "get",
  });
};

AssetAttributeService.updateAssetAttribute = function (data) {
  // console.log("🚀 ~ data:", data);
  const { Id, ...requestBody } = data;
  // console.log("🚀 ~ rest:", requestBody);

  return lossClient({
    url: "/AssetAttribute/Edit",
    method: "put",
    headers: {
      "X-requestid": data.Id,
    },
    data: requestBody,
  });
};

AssetAttributeService.deleteAssetAttribute = function (data) {
  // console.log("🚀 ~ AssetAttributeService.deleteAssetAttribute ~ data:", data);
  const { Id, ...requestBody } = data;
  // console.log("🚀 ~ requestBody:", requestBody);
  return lossClient({
    url: "/AssetAttribute/Delete",
    method: "delete",
    headers: {
      "X-requestid": data.Id,
    },
    data: requestBody,
  });
};

export default AssetAttributeService;
